module.exports = __webpack_public_path__ + "img/icon-send-email.7fc9a31b.svg";